import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineClose } from "react-icons/md";
import CancelForm from "./cancelModalForm/CancelForm";
import "./CancelModal.css";

const CancelModal = ({ showModal, setShowModal }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    document.body.classList.remove("isOpenModal");

    setShowModal(false);
  };

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [showModal]);

  return (
    <>
      {showModal && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-75 md:py-4 z-20">
          <div className="cancel-modal-custom bg-white dark:bg-[#111] w-full h-[650px] md:h-full md:max-w-[600px] overflow-y-auto rounded-[20px] border border-gray-400 relative ml-4 mr-4 md:ml-0 md:mr-0 p-5 md:px-5 md:py-5 xl:h-auto mt-[5em]">
            <div className="absolute top-5 right-5">
              <MdOutlineClose
                className="h-6 w-6 cursor-pointer text-[#000] dark:text-white"
                onClick={handleClose}
              />
            </div>
            <div className="flex flex-col gap-5 py-5 h-full justify-start">
              <div className="flex flex-col items-center md:items-center gap-2 ">
                <h2 className=" prose-t24_bold lg:prose-t32_bold text-secondary_black dark:text-white">
                  {t("cancellationReason")}
                </h2>
                <span className="prose-t14_regular text-[#323232] dark:text-[#9a9a9a] text-center">
                  {t("pleaseShareYourReason")}
                </span>
              </div>
              <div>
                <CancelForm setShowModal={setShowModal} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CancelModal;
